import { Box, Paper, Typography, Avatar } from "@mui/material";
import { PostClick } from "../../../AnalyticsData.ts";
import { useNavigate } from "react-router-dom";

export default function AppLinksByPublicProfile({
  AccountId,
  list,
  profile,
  type,
  sameAccount = false,
}) {
  const navigate = useNavigate();

  const handleClick = async (key, link) => {
    // Add a small delay to ensure touch event is properly registered on iOS
    setTimeout(async () => {
      if (sameAccount === false) {
        await PostClick({
          linkId: key,
          userId: AccountId ?? null,
          gender: profile.profile.gender ?? null,
          country: profile.country ?? null,
          category: link.category,
          date: new Date(),
        });
      }
      if (validateURL(link.body)) {
        // Use a more iOS-friendly approach
        if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
          window.location.href = link.body;
        } else {
          window.open(link.body, "_blank");
        }
      } else {
        navigate("/404");
      }
    }, 100); // Small delay to ensure touch event completes
  };

  const validateURL = (url) => {
    try {
      new URL(url);
      return true;
    } catch (e) {
      return false;
    }
  };

  return (
    <Box>
      {type == "socialLinks"
        ? list.map((site, key) => (
            <Paper
              sx={{
                padding: "0.8rem 1.5rem",
                borderRadius: "10px",
                background: "#f5f5f5f5",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center", // S
                margin: "0.6rem 0",
                // border: `2px solid ${site.color}`,
                marginTop: "15px",
                boxShadow: "0 0.4rem 0.8rem rgba(20, 43, 58, 0.50)",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)", // Apply scale transformation on hover
                },
                // iOS touch improvements
                WebkitTapHighlightColor: "rgba(0, 0, 0, 0.1)",
                WebkitTouchCallout: "none",
                WebkitUserSelect: "none",
                userSelect: "none",
                touchAction: "manipulation",
                minHeight: "44px", // Ensure minimum touch target size for iOS
              }}
              key={key}
              onClick={() => handleClick(key, site)}
            >
              <Box color={site.color} fontSize="18px">
                {site.icon}
              </Box>

              <Typography
                sx={{
                  color: "#333333",
                  fontWeight: 1000,
                  margin: "auto",
                }}
              >
                {site.name}
              </Typography>
            </Paper>
          ))
        : list.map((site, key) => (
            <Paper
              sx={{
                padding: "0.8rem 1.5rem",
                borderRadius: "10px",
                position: "relative",
                background: "#f5f5f5f5",
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                margin: "0.6rem 0",
                marginTop: "15px",
                boxShadow: "0 0.4rem 0.8rem rgba(20, 43, 58, 0.50)",
                transition: "transform 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                },
                "&::after": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  width: "10px",
                  backgroundColor: "#ff715b",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                },
                // iOS touch improvements
                WebkitTapHighlightColor: "rgba(0, 0, 0, 0.1)",
                WebkitTouchCallout: "none",
                WebkitUserSelect: "none",
                userSelect: "none",
                touchAction: "manipulation",
                minHeight: "44px", // Ensure minimum touch target size for iOS
              }}
              onClick={() => handleClick(key, site.body)}
              key={key}
            >
              <Avatar
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "60%",
                  border: "1px solid rgba(10, 20, 20, 0.12)",
                  marginBottom: "0.2rem",
                }}
                src={site.icon}
              />

              <Typography
                sx={{
                  color: "#333333",
                  fontWeight: 1000,
                  fontSize: "15px",
                  margin: "auto",
                }}
              >
                {site.name}
              </Typography>
            </Paper>
          ))}
    </Box>
  );
}
